module.exports = __webpack_public_path__ + "img/17-1_03.4071021c.jpg";